
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/van/overlanding",
      function () {
        return require("private-next-pages/wheels/van/overlanding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/van/overlanding"])
      });
    }
  